export const FormBlock = ({ header, children }: { header: string; children: React.ReactNode }) => {
  return (
    <div className='bg-white p-4 flex flex-col gap-6'>
      <h2 className='font-header text-2xl font-semibold text-gray-500'>{header}</h2>
      {children}
    </div>
  );
};
